import React from 'react';
import styled from 'styled-components';

import ConnectionsMobileSubnav from './ConnectionsMobileSubnav';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import SectionBreadcrumb from '../../../_molecules/SectionBreadcrumb';
import SectionBreadcrumbs from '../../../_molecules/SectionBreadcrumbs';
import SectionHeader from '../../../_molecules/SectionHeader';
import SearchMembersLikeMe from '../../../searches/SearchMembersLikeMe';
import LoadingArea from '@molecules/LoadingArea';
import {
    BodyLarge,
    ChipLightGray,
    DivWithShadowAlternate,
    H3,
    LinkSmall,
    SectionWrapperInner,
    SectionWrapperOuter,
} from '@styled';

import { SearchModeContext } from '../../../../../../algolia-search/js/context/searchContext';
import useMembersLikeMeFilterChips from '../../../../hooks/useMembersLikeMeFilterChips';
import useViewer from '@hooks/useViewer';
import useDocumentTitle from '@hooks/useDocumentTitle';

const SearchContainer = styled(DivWithShadowAlternate)`
    margin-top: 40px;
    padding: 32px;
`;

export const MembersLikeMePage = () => {
    const { viewer } = useViewer();
    const { filterChips } = useMembersLikeMeFilterChips({ member: viewer });
    useDocumentTitle('Members Like Me');

    if (!viewer) {
        return <LoadingArea />;
    }

    return (
        <ErrorHandler>
            <TrackPageView>
                <ConnectionsMobileSubnav />

                <SectionWrapperOuter>
                    <SectionWrapperInner>
                        <div className="fade-in-fast pb-4">
                            <SectionHeader title="My ICSC Connections" />

                            <div className="flex justify-content-between mb-1.5rem">
                                <SectionBreadcrumbs>
                                    <SectionBreadcrumb route="/my-icsc/connections">Connections</SectionBreadcrumb>
                                    <SectionBreadcrumb isActive>Members Like Me</SectionBreadcrumb>
                                </SectionBreadcrumbs>
                            </div>

                            <H3 className="mt-2 mb-3">Members Like Me</H3>

                            <BodyLarge className="mb-1.5rem">
                                These ICSC members occupy roles similar to yours. Start a conversation, schedule a
                                meeting, or view available listings from members who share your interests.
                            </BodyLarge>

                            {filterChips.length > 0 && (
                                <div className="d-flex flex-wrap">
                                    {filterChips.map((filter, index) => (
                                        <ChipLightGray key={index} className="mb-0.5rem mr-0.5rem">
                                            {filter}
                                        </ChipLightGray>
                                    ))}
                                </div>
                            )}

                            <SearchContainer>
                                <SearchModeContext.Provider value={{ showFilters: false }}>
                                    <SearchMembersLikeMe
                                        parentView="Connections"
                                        showPagingToolbar
                                        showSearchBox
                                        showSearchOptions
                                        updateSearchStateUrl
                                    />
                                </SearchModeContext.Provider>
                            </SearchContainer>
                        </div>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};
